import { render, staticRenderFns } from "./NoItemsToDisplayCpt.vue?vue&type=template&id=7a139b48&scoped=true&"
import script from "./NoItemsToDisplayCpt.vue?vue&type=script&lang=ts&"
export * from "./NoItemsToDisplayCpt.vue?vue&type=script&lang=ts&"
import style0 from "./NoItemsToDisplayCpt.vue?vue&type=style&index=0&id=7a139b48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a139b48",
  null
  
)

export default component.exports